"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgPower = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M20.444 9.86A.503.503 0 0020 9.6h-7.376l1.864-8.058a.475.475 0 00-.284-.544.513.513 0 00-.61.16l-10 13.44a.464.464 0 00-.041.501.503.503 0 00.447.261h7.376l-1.864 8.055a.475.475 0 00.284.543.513.513 0 00.611-.16l10-13.44a.464.464 0 00.037-.499z" })));
};
exports.default = SvgPower;
//# sourceMappingURL=Power.js.map